import { render, staticRenderFns } from "./previewItem.vue?vue&type=template&id=f93fc8d6&scoped=true"
import script from "./previewItem.vue?vue&type=script&lang=js"
export * from "./previewItem.vue?vue&type=script&lang=js"
import style0 from "./previewItem.vue?vue&type=style&index=0&id=f93fc8d6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f93fc8d6",
  null
  
)

export default component.exports